export default __webpack_public_path__ + "524b17460e392056389a4a2cf4466687.svg";